import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Recepient Name',
    field: 'recepientName',
    filter: 'text',
    searchable: true,
  }, 
  {
    title: 'Email',
    field: 'toAddress',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Workorder Number',
    field: 'workorderNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Template Name',
    field: 'templateName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Created On',
    field: 'createdOn',
    filter: 'text',
    searchable: true,
  },
];
